import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BrowseJobsAPI from '../Apis/BrowseJobsApi';
import Footer from '../app/Footer';
import Navbar from '../navigation/Navbar';
import BrowseJobsDesc from './BrowseJobsDesc';

function BrowseJobs() {
    const {job} = useParams();
    const [currentJob, setCurrentJob] = useState({});
    
    useEffect(() => {
      setCurrentJob(BrowseJobsAPI.getJob(job));  
    }, [job])

    return (
        <>
            <Navbar selected='Browse Jobs'></Navbar>
            <BrowseJobsDesc job={currentJob} />
            <Footer></Footer>
        </>
    );
}

export default BrowseJobs;